import { GOOGLE_PLATFORM } from '../config/scheduled-enrichment-platform';
import { useScheduledGoogleStore } from '../store/scheduled-google.store';
import type { EnrichmentContext } from '../types/enrichment-context.types';

import { useScheduledEnrichmentContext } from './scheduled-enrichment-adapter';

/**
 * Builds the {@link EnrichmentContext} for the Google Ads (GMC) scheduled
 * enrichment flow. Thin wrapper over the shared scheduled-enrichment core with
 * Google's platform config and its isolated persisted store.
 */
export function useScheduledGoogleEnrichmentContext(): EnrichmentContext {
  return useScheduledEnrichmentContext(GOOGLE_PLATFORM, useScheduledGoogleStore);
}
